import { Link } from 'react-router-dom';
import { useScrollAnimation } from '@/hooks/useScrollAnimation';

const capabilities = [
  {
    icon: 'ri-building-2-line',
    title: 'Galpones Industriales',
    desc: 'Estructuras metálicas de gran envergadura con cubierta, revestimiento y terminaciones llave en mano.',
    stat: '+120',
    statLabel: 'Galpones construidos',
  },
  {
    icon: 'ri-hammer-line',
    title: 'Estructuras Metálicas',
    desc: 'Fabricación, montaje e instalación de estructuras de acero para proyectos industriales y mineros.',
    stat: '+80',
    statLabel: 'Montajes ejecutados',
  },
  {
    icon: 'ri-store-2-line',
    title: 'Locales Comerciales',
    desc: 'Construcción de malls, supermercados, concesionarias y locales con fachada corporativa.',
    stat: '+45',
    statLabel: 'Locales entregados',
  },
  {
    icon: 'ri-road-map-line',
    title: 'Obras Civiles',
    desc: 'Fundaciones, pavimentación, muros de contención, redes sanitarias y movimiento de tierras.',
    stat: '+60',
    statLabel: 'Obras completadas',
  },
  {
    icon: 'ri-water-flash-line',
    title: 'Pisciculturas',
    desc: 'Infraestructura acuícola especializada: estanques, galpones de procesamiento y sistemas hidráulicos.',
    stat: '+15',
    statLabel: 'Centros acuícolas',
  },
  {
    icon: 'ri-shield-check-line',
    title: 'Proyectos Mineros',
    desc: 'Experiencia certificada en minería con estándares de seguridad SERNAGEOMIN. Cero accidentes.',
    stat: 'Premio',
    statLabel: 'SERNAGEOMIN 2007',
  },
];

const CorporateCapabilities = () => {
  const { ref: leftRef, isVisible: leftVisible } = useScrollAnimation();
  const { ref: gridRef, isVisible: gridVisible } = useScrollAnimation();

  return (
    <section className="py-24 bg-[#F8FAFC]">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-14 items-start">
          {/* Left: Title + CTA */}
          <div
            ref={leftRef}
            className={`lg:col-span-4 lg:sticky lg:top-28 reveal-left ${leftVisible ? 'reveal-visible' : ''}`}
          >
            <span className="text-[#C88A2A] text-xs font-bold uppercase tracking-[0.2em]">Capacidades</span>
            <h2 className="text-3xl md:text-4xl font-heading font-bold text-[#0C1D2E] mt-3 mb-5 leading-tight">
              Experiencia técnica<br />
              <span className="text-[#475569]">a escala industrial</span>
            </h2>
            <p className="text-[#475569] text-base leading-relaxed mb-8">
              Nuestra capacidad operativa abarca desde la fabricación de estructuras metálicas hasta la entrega llave en mano de complejos industriales. Cada proyecto ejecutado refuerza nuestra experiencia minera, comercial e industrial.
            </p>
            <Link
              to="/servicios"
              className="inline-flex items-center gap-2 text-[#C88A2A] font-bold text-sm hover:gap-3 transition-all duration-200 uppercase tracking-wide"
            >
              Ver todos los servicios <i className="ri-arrow-right-line"></i>
            </Link>
          </div>

          {/* Right: Capabilities Grid */}
          <div ref={gridRef} className="lg:col-span-8">
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-5">
              {capabilities.map((cap, i) => (
                <div
                  key={cap.title}
                  className={`group bg-white border border-[#E2E8F0] p-6 rounded-lg hover:border-[#C88A2A]/30 hover:shadow-sm hover:-translate-y-1 transition-all duration-300 reveal ${gridVisible ? 'reveal-visible' : ''} reveal-delay-${(i + 1) * 100}`}
                >
                  <div className="flex items-start justify-between mb-4">
                    <div className="w-10 h-10 flex items-center justify-center bg-[#0C1D2E] rounded-md">
                      <i className={`${cap.icon} text-white text-lg`}></i>
                    </div>
                    <div className="text-right">
                      <div className="text-xl font-heading font-bold text-[#C88A2A]">{cap.stat}</div>
                      <div className="text-[#64748B] text-[10px] uppercase tracking-wider">{cap.statLabel}</div>
                    </div>
                  </div>
                  <h3 className="font-heading font-bold text-[#0C1D2E] text-base mb-2 uppercase tracking-wide">
                    {cap.title}
                  </h3>
                  <p className="text-[#475569] text-sm leading-relaxed">
                    {cap.desc}
                  </p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CorporateCapabilities;